import type { Vps } from "./types";

const pendingLabels: Record<string, string> = {
  toStart: "VPS se spouští",
  toStop: "VPS se zastavuje",
  toReboot: "VPS se restartuje",
  toEnableVnc: "Aktivuje se VNC",
  toDisableVnc: "Deaktivuje se VNC",
  toDestroy: "VPS se odstraňuje",
  toUndefine: "VPS se odstraňuje",
  toBackup: "Probíhá interní záloha",
  toDefine: "VPS se vytváří",
  needInspect: "VPS vyžaduje kontrolu správcem",
};

export function isVpsBusy(vps: Pick<Vps, "pendingOperation">): boolean {
  return vps.pendingOperation !== null;
}

export function pendingOperationLabel(operation: string | null): string | null {
  if (operation === null) return null;
  return pendingLabels[operation] ?? `Probíhá operace ${operation}`;
}

export function stateLabel(state: string): string {
  if (state === "RUNNING") return "Spuštěný";
  if (state === "SHUTOFF") return "Zastavený";
  if (state === "PAUSED") return "Pozastavený";
  return state;
}

export type StateTone = "success" | "neutral" | "warning" | "danger";

export function vpsTone(vps: Pick<Vps, "state" | "pendingOperation">): StateTone {
  if (vps.pendingOperation === "needInspect") return "danger";
  if (vps.pendingOperation !== null) return "warning";
  if (vps.state === "RUNNING") return "success";
  return "neutral";
}

export function canStart(vps: Vps): boolean {
  return !isVpsBusy(vps) && vps.state === "SHUTOFF";
}

export function canStop(vps: Vps): boolean {
  return !isVpsBusy(vps) && vps.state === "RUNNING";
}

export function canReboot(vps: Vps): boolean {
  return !isVpsBusy(vps) && vps.state === "RUNNING";
}
